import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import VideocamIcon from '@material-ui/icons/Videocam';
import { useTranslation } from 'react-i18next';

const RootContainer = styled.div`
  padding: 12px;
  background-color: #FFF;
  width: 550px;
  height: fit-content;
  position: relative;
  border-radius: 12px;
  outline: 0;
  text-align: center;
`;

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '2000 !important' as any,
  },
  cancel: {
    color: '#5c8df3',
    marginRight: '20px',
  },
  retry: {
    backgroundColor: '#5c8df3',
  },
}));

const ButtonGroupContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-size: 16px;
`;

const TimeoutPage = ({
  close,
  retryCall,
}: {
  close: () => void;
  retryCall: () => void;
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Modal
      open
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
    >
      <RootContainer>
        <h2>
          {t('call.no_answer', 'Call not answered')}
        </h2>
        <div>
          {t('call.no_answer_hint', 'Call not answered')}
        </div>
        <ButtonGroupContainer>
          <Button
            className={classes.cancel}
            onClick={close}
            color="primary"
          >
            {t('call.cancel', 'Cancel')}
          </Button>
          <Button
            className={classes.retry}
            onClick={retryCall}
            variant="contained"
            color="primary"
            startIcon={<VideocamIcon />}
            size="small"
          >
            {t('call.retry', 'Retry')}
          </Button>
        </ButtonGroupContainer>
      </RootContainer>
    </Modal>
  );
};

export default TimeoutPage;
